require(['ch_search'], function () {
    const searchForm = document.getElementById('search-form');
    const hubSelectors = Array.from(document.querySelectorAll('.js-hub-select'));
    const searchInput = document.querySelector('.js-search-by-keyword input[type=text]');

    let lastHubSelected = CH.Hub.uri;

    // A coarse pointer means a phone or a tablet, and there the operating system's own
    // picker is a better control than anything reimplemented here -- it is full-screen,
    // it scrolls with a thumb, and it is what every other select on the device does. The
    // desktop popup is the one that is worth replacing.
    const canEnhanceHubSelect =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    let hubSelectSeq = 0;

    if (hubSelectors.length) {
        hubSelectors.forEach(function (hubSelector) {
            hubSelector.addEventListener('change', onChange);
            hubSelector.addEventListener('click', onClick);

            if (canEnhanceHubSelect) {
                enhanceHubSelect(hubSelector);
            }
        });
    }

    /**
     * Draw the location picker ourselves.
     *
     * A <select>'s open state belongs to the operating system: on macOS it is a full-height
     * system list in the system font, opaque over the header and the category nav, with the
     * system's own blue highlight and tick. No stylesheet reaches any of it. This used to be
     * handed to SemanticUI's dropdown module by ch_header_light's initHubSelector, which was
     * commented out when the site moved off SemanticUI's JS, and nothing replaced it.
     *
     * The <select> stays in the DOM and stays authoritative: this only hides it, mirrors it
     * into a listbox, and writes the choice back to it before firing its change event. Every
     * rule about where a hub change navigates to still lives in onChange above, reading
     * this.value, and is untouched.
     */
    function enhanceHubSelect(select) {
        if (select.dataset.chHubSelect === 'on') {
            return;
        }
        select.dataset.chHubSelect = 'on';

        const id = 'ch-hub-select-' + (++hubSelectSeq);
        const options = Array.from(select.options);
        const ariaLabel = select.getAttribute('aria-label');

        const wrapper = document.createElement('div');
        wrapper.className = 'ch-hub-select';

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'ch-hub-select__trigger';
        trigger.setAttribute('aria-haspopup', 'listbox');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-controls', id);

        const label = document.createElement('span');
        label.className = 'ch-hub-select__label';

        const caret = document.createElement('span');
        caret.className = 'ch-hub-select__caret';
        caret.setAttribute('aria-hidden', 'true');

        trigger.appendChild(label);
        trigger.appendChild(caret);

        const menu = document.createElement('ul');
        menu.id = id;
        menu.className = 'ch-hub-select__menu';
        menu.setAttribute('role', 'listbox');
        menu.hidden = true;

        if (ariaLabel) {
            trigger.setAttribute('aria-label', ariaLabel);
            menu.setAttribute('aria-label', ariaLabel);
        }

        const items = options.map(function (option, i) {
            const item = document.createElement('li');
            item.id = id + '-option-' + i;
            item.className = 'ch-hub-select__option';
            item.setAttribute('role', 'option');
            item.textContent = option.textContent.trim();
            menu.appendChild(item);
            return item;
        });

        // Insert in place, then take the select inside, so anything the template positions
        // against the original parent (the browse heading's chevron) keeps its anchor.
        select.parentNode.insertBefore(wrapper, select);
        wrapper.appendChild(trigger);
        wrapper.appendChild(menu);
        wrapper.appendChild(select);
        // Drop the SemanticUI classes as well as adding ours. They are not decoration on a
        // hidden element, they are a specificity problem: `.ui.selection.dropdown` sets
        // display: inline-block from three classes, so a one-class `display: none` loses to
        // it and the native select stays on screen next to its own replacement.
        select.classList.add('ch-hub-select__native');
        select.classList.remove('ui', 'selection', 'dropdown');

        let activeIndex = select.selectedIndex >= 0 ? select.selectedIndex : 0;

        function syncSelected() {
            const selected = options[select.selectedIndex];
            label.textContent = selected ? selected.textContent.trim() : '';

            items.forEach(function (item, i) {
                const isSelected = i === select.selectedIndex;
                item.classList.toggle('is-selected', isSelected);
                item.setAttribute('aria-selected', String(isSelected));
            });
        }

        function setActive(index) {
            activeIndex = Math.min(Math.max(index, 0), items.length - 1);

            items.forEach(function (item, i) {
                item.classList.toggle('is-active', i === activeIndex);
            });

            const item = items[activeIndex];
            if (!item) {
                return;
            }
            trigger.setAttribute('aria-activedescendant', item.id);

            // Focus stays on the trigger for aria-activedescendant to work, so nothing
            // scrolls the list for us.
            const top = item.offsetTop;
            const bottom = top + item.offsetHeight;
            if (top < menu.scrollTop) {
                menu.scrollTop = top;
            }
            else if (bottom > menu.scrollTop + menu.clientHeight) {
                menu.scrollTop = bottom - menu.clientHeight;
            }
        }

        function openMenu() {
            if (!menu.hidden) {
                return;
            }
            menu.hidden = false;
            wrapper.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            setActive(select.selectedIndex >= 0 ? select.selectedIndex : 0);
        }

        function closeMenu() {
            if (menu.hidden) {
                return;
            }
            menu.hidden = true;
            wrapper.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.removeAttribute('aria-activedescendant');
        }

        function choose(index) {
            closeMenu();

            // Re-picking the current city is a no-op, exactly as it is on a native select.
            // Without this the visitor reloads the page they are already on.
            if (index === select.selectedIndex || !options[index]) {
                return;
            }

            select.selectedIndex = index;
            syncSelected();
            select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        function findByFirstCharacter(character, from) {
            const needle = character.toLowerCase();

            for (let step = 1; step <= items.length; step++) {
                const i = (from + step + items.length) % items.length;
                if (items[i].textContent.toLowerCase().indexOf(needle) === 0) {
                    return i;
                }
            }

            return -1;
        }

        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            if (menu.hidden) {
                openMenu();
            }
            else {
                closeMenu();
            }
        });

        trigger.addEventListener('keydown', function (e) {
            if (e.metaKey || e.ctrlKey || e.altKey) {
                return;
            }

            switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                if (menu.hidden) {
                    openMenu();
                }
                else {
                    setActive(activeIndex + 1);
                }
                break;
            case 'ArrowUp':
                e.preventDefault();
                if (menu.hidden) {
                    openMenu();
                }
                else {
                    setActive(activeIndex - 1);
                }
                break;
            case 'Home':
                if (!menu.hidden) {
                    e.preventDefault();
                    setActive(0);
                }
                break;
            case 'End':
                if (!menu.hidden) {
                    e.preventDefault();
                    setActive(items.length - 1);
                }
                break;
            case 'Enter':
            case ' ':
                e.preventDefault();
                if (menu.hidden) {
                    openMenu();
                }
                else {
                    choose(activeIndex);
                }
                break;
            case 'Escape':
                if (!menu.hidden) {
                    e.preventDefault();
                    closeMenu();
                }
                break;
            default:
                // Jump to a city by its first letter, the way a native select does.
                if (e.key.length === 1 && e.key.trim()) {
                    const from = menu.hidden ? select.selectedIndex : activeIndex;
                    const match = findByFirstCharacter(e.key, from);
                    if (match !== -1) {
                        e.preventDefault();
                        openMenu();
                        setActive(match);
                    }
                }
            }
        });

        // Keep the press from blurring the trigger: the list items are not focusable, so a
        // blur here would close the menu on focusout before the click ever landed.
        menu.addEventListener('mousedown', function (e) {
            e.preventDefault();
        });

        menu.addEventListener('click', function (e) {
            const item = e.target.closest('.ch-hub-select__option');
            if (item) {
                choose(items.indexOf(item));
            }
        });

        menu.addEventListener('mouseover', function (e) {
            const item = e.target.closest('.ch-hub-select__option');
            if (item) {
                setActive(items.indexOf(item));
            }
        });

        wrapper.addEventListener('focusout', function (e) {
            if (!wrapper.contains(e.relatedTarget)) {
                closeMenu();
            }
        });

        document.addEventListener('mousedown', function (e) {
            if (!wrapper.contains(e.target)) {
                closeMenu();
            }
        });

        syncSelected();
    }

    function onChange() {
        const hub = this.value.toLowerCase();

        window.Filters.hub = hub;
        window.Filters.kw = searchInput && searchInput.value
            ? encodeURIComponent(searchInput.value)
            : null;

        Filters.suggest = null;

        // make it so search form submission respects the newly selected hub
        if (searchForm) {
            searchForm.action = searchForm.action.replace(lastHubSelected, hub);
        }
        lastHubSelected = hub;

        // when going to "all" classes...
        if (hub === 'all') {
            if (window.Filters.category) {
                window.location.href = '/' + hub + '/classes/' + window.Filters.category;
            } else {
                window.location.href = '/' + hub + '/classes';
            }
            return;
        }

        // when leaving "all" classes
        if (window.location.pathname.indexOf('/all/') === 0) {
            window.location.href = window.location.href.replace('/all/', `/${hub}/`);
            return;
        }

        if (!window.Filters.kw) {
            // If you're not on a hub-specific page (eg: /contact-us), go to the hub page
            if (window.location.pathname.indexOf('/' + CH.Hub.uri + '/') === -1) {
                window.location.href = '/' + hub;
            } else if (CH.is_course_page) {
                window.location.href = '/' + window.Filters.hub + '/classes';
            } else if (CH.Hub.uri) {
                window.location.href = window.location.href.replace(CH.Hub.uri, hub);
            } else {
                window.location.href = '/' + hub;
            }
        }
    }

    function onClick() {

    }
});

define("ch_semantic_search", function(){});

